import { Injectable } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';
import { Folder } from 'common/xislivechat/models/folder';
import { FolderService } from 'common/folders-service/folder.service';

@Injectable({
  providedIn: 'root'
})
export class ChatFolderService extends FolderService {
  constructor(bcRestApi: BcRestApi) {
    super(bcRestApi, Folder.TYPES.chat);
  }
}
